import { endOfMonth, endOfWeek, isSameDay, isWithinInterval, startOfMonth, startOfWeek } from 'date-fns';
import type { Mode } from '../../../../../types';
import type { EventItem } from '../Agenda';

type P = {
  date: Date;
  events?: EventItem[];
  mode: Mode;
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
};

const getIntervalStart = (mode: 'month' | 'week', date: Date, weekStartsOn: P['weekStartsOn']) => {
  switch (mode) {
    case 'month':
      return startOfMonth(date);
    case 'week':
      return startOfWeek(date, { weekStartsOn });
  }
};

const getIntervalEnd = (mode: 'month' | 'week', date: Date, weekStartsOn: P['weekStartsOn']) => {
  switch (mode) {
    case 'month':
      return endOfMonth(date);
    case 'week':
      return endOfWeek(date, { weekStartsOn });
  }
};

export const useShouldShowTodayEmptyPlaceholder = ({ date, events, mode, weekStartsOn }: P) => {
  if (mode === 'day') {
    return false;
  }

  const today = new Date();
  if (
    !isWithinInterval(today, {
      end: getIntervalEnd(mode, date, weekStartsOn),
      start: getIntervalStart(mode, date, weekStartsOn),
    })
  ) {
    return false;
  }

  return !events?.some((event) => isSameDay(event.startTime, today));
};
